import React from 'react';
export const CallToAction = () => {
  const checkoutUrl = 'https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-adv';
  return <section className="mb-10" data-id="element-16">
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-17">
        Begin Vandaag Met De Transformatie
      </h2>
      <div className="w-full mb-6" data-id="element-18">
        <a href={checkoutUrl} data-id="element-19">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kmdhUzYLBMY9Kw3oqsxgTL/Scherm%C2%ADafbeelding_2025-08-15_om_15.56.55.png" alt="Vrouw communiceert met haar golden retriever in een gezellige woonkamer" className="w-full h-auto rounded-lg shadow-md hover:opacity-95 transition-opacity" data-id="element-20" />
        </a>
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-21">
          Begin vandaag nog met het leren van de hondentaal vanuit je eigen
          woonkamer
        </p>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-22">
        Sandra, met wie ik dit artikel begon, heeft inmiddels de volledige
        cursus doorlopen. Vorige week stuurde ze me een foto van haarzelf en
        Benny, ontspannen lopend in hetzelfde park waar ze maanden geleden zo'n
        vervelende ervaring had.
      </p>
      <p className="mb-6 italic" data-id="element-23">
        "Amee," schreef ze, "ik kan niet geloven dat dit dezelfde hond is. Maar
        eigenlijk is hij helemaal niet veranderd - ik ben veranderd. Ik spreek
        nu zijn taal."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-24">
        Die transformatie is ook voor jou mogelijk. De verborgen taalbarrière
        tussen jou en je hond hoeft niet voor altijd te bestaan.
      </p>
      <div className="bg-red-50 p-3 rounded-lg mb-6 border-2 border-red-300" data-id="element-25">
        <p className="text-center font-bold text-red-700" data-id="element-26">
          ⚠️ ZOMERKORTING: SLECHTS GELDIG TOT EIND DEZE WEEK! ⚠️
        </p>
      </div>
      <a href={checkoutUrl} className="block no-underline" data-id="element-27">
        <div className="bg-gray-50 p-6 rounded-lg mb-8 border border-gray-200 hover:bg-gray-100 transition-colors" data-id="element-28">
          <div className="flex justify-between items-center mb-4" data-id="element-29">
            <div data-id="element-30">
              <h3 className="text-lg font-bold" data-id="element-31">Tijdelijke Zomerkorting</h3>
              <p className="text-gray-600 text-sm" data-id="element-32">
                Normale prijs: <span className="line-through" data-id="element-33">€223,90</span>
              </p>
              <p className="text-gray-600 text-sm" data-id="element-34">
                Standaard aanbieding: <span className="line-through" data-id="element-35">€197</span>
              </p>
            </div>
            <div className="text-right" data-id="element-36">
              <span className="text-2xl font-bold text-blue-800" data-id="element-37">€127</span>
              <p className="text-sm text-green-600" data-id="element-38">Je bespaart nu €96,90!</p>
            </div>
          </div>
          <button className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 mb-4 animate-pulse" data-id="element-39">
            CLAIM JE ZOMERKORTING - SLECHTS €127
          </button>
          <p className="text-center text-red-600 font-semibold mb-3" data-id="element-40">
            ⏰ Deze aanbieding verloopt over: 4 dagen, 17 uur en 32 minuten
          </p>
          <p className="text-center text-sm text-gray-600 mb-2" data-id="element-41">
            100% tevredenheidsgarantie - 30 dagen niet-goed-geld-terug
          </p>
          <div className="flex justify-center space-x-2" data-id="element-42">
            <span className="text-yellow-500" data-id="element-43">★★★★</span>
            <span className="text-gray-300" data-id="element-44">★</span>
            <span className="text-sm text-gray-600" data-id="element-45">
              4,3/5 op basis van 584+ reviews
            </span>
          </div>
        </div>
      </a>
      <p className="mb-6 leading-relaxed" data-id="element-46">
        <span className="font-bold" data-id="element-47">Wacht niet langer!</span> Deze speciale
        zomerkorting is slechts tijdelijk beschikbaar en loopt aan het einde van
        deze week af. Daarna gaat de prijs weer terug naar €197.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-48">
        <a href={checkoutUrl} className="text-blue-600 hover:underline" data-id="element-49">
          Klik hier
        </a>{' '}
        om toegang te krijgen tot 'Liefdevol Communiceren' en begin vandaag nog
        met het doorbreken van de taalbarrière. Met onze 30-dagen garantie heb
        je niets te verliezen, behalve de stress, frustratie en twijfels die je
        nu ervaart.
      </p>
      <p className="font-semibold text-blue-800 text-center mb-6" data-id="element-50">
        <a href={checkoutUrl} className="hover:underline" data-id="element-51">
          Je hond wacht al zijn hele leven op het moment dat jullie elkaar echt
          begrijpen. Vandaag kan die dag zijn.
        </a>
      </p>
    </section>;
};